import initKycMFEApiService from 'components/KycMFE/initKycMFEApiService';
import initBillingsMFEApiService from 'components/BillingsMFE/initBillingsMFEApiService';
import initDatabasesMFEApiService from '../../components/DatabasesMFE/initDatabasesMFEApiService';
import initIntegrationsMFEApiService from '../../components/IntegrationsMFE/initIntegrationsMFEApiService';
import initRdiMFEApiService from '../../components/RdiMFE/initRdiMFEApiService';
import initSubscriptionsMFEApiService from '../../screens/SubscriptionsAndDatabases/Subscriptions/SubscriptionsMFE/initSubscriptionsMFEApiService';
import initAiServicesApiClients from '../../components/AiServicesMFE/initAiServicesApiClients';

const initMfesApiServices = () => {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  Promise.all([
    initDatabasesMFEApiService(),
    initIntegrationsMFEApiService(),
    initRdiMFEApiService(),
    initSubscriptionsMFEApiService(),
    initAiServicesApiClients(),
    initKycMFEApiService(),
    initBillingsMFEApiService()
  ]);
};

export default initMfesApiServices;
